// Filters on the main page — локальный справочник год/мотор (без API)

const FITMENT_TREE = {
  ford: {
    1999: ['7-3l'],
    2000: ['7-3l'],
    2001: ['7-3l'],
    2002: ['7-3l'],
    2003: ['7-3l', '6-0l'],
    2004: ['6-0l'],
    2005: ['6-0l'],
    2006: ['6-0l'],
    2007: ['6-0l'],
    2008: ['6-4l'],
    2009: ['6-4l'],
    2010: ['6-4l'],
    2011: ['6-7l'],
    2012: ['6-7l'],
    2013: ['6-7l'],
    2014: ['6-7l'],
    2015: ['6-7l'],
    2016: ['6-7l'],
    2017: ['6-7l'],
    2018: ['6-7l', '3-0l'],
    2019: ['6-7l', '3-0l'],
    2020: ['6-7l', '3-0l'],
    2021: ['6-7l'],
    2022: ['6-7l'],
    2023: ['6-7l'],
    2024: ['6-7l'],
    2025: ['6-7l'],
    2026: ['6-7l'],
  },
  /** Ram Cummins 6.7L — 2007–2024 */
  'dodge-ram': {
    2007: ['6-7l'],
    2008: ['6-7l'],
    2009: ['6-7l'],
    2010: ['6-7l'],
    2011: ['6-7l'],
    2012: ['6-7l'],
    2013: ['6-7l'],
    2014: ['6-7l'],
    2015: ['6-7l'],
    2016: ['6-7l'],
    2017: ['6-7l'],
    2018: ['6-7l'],
    2019: ['6-7l'],
    2020: ['6-7l'],
    2021: ['6-7l'],
    2022: ['6-7l'],
    2023: ['6-7l'],
    2024: ['6-7l'],
  },
  /** Ram EcoDiesel 3.0L — 2014–2023 */
  'ram-ecodiesel': {
    2014: ['3-0l'],
    2015: ['3-0l'],
    2016: ['3-0l'],
    2017: ['3-0l'],
    2018: ['3-0l'],
    2019: ['3-0l'],
    2020: ['3-0l'],
    2021: ['3-0l'],
    2022: ['3-0l'],
    2023: ['3-0l'],
  },
  /** GM/Chevy Duramax: 6.6L 2004–2026, 2.8L LWN 2016–2021, 3.0L LM2 2020–2022 */
  'gm-chevy': {
    2004: ['6-6l-lly-lbz'],
    2005: ['6-6l-lly-lbz'],
    2006: ['6-6l-lly-lbz'],
    2007: ['6-6l-lly-lbz', '6-6l-lmm'],
    2008: ['6-6l-lmm'],
    2009: ['6-6l-lmm'],
    2010: ['6-6l-lmm'],
    2011: ['6-6l-lml'],
    2012: ['6-6l-lml'],
    2013: ['6-6l-lml'],
    2014: ['6-6l-lml'],
    2015: ['6-6l-lml'],
    2016: ['6-6l-lml', '2-8l-lwn'],
    2017: ['6-6l-l5p', '2-8l-lwn'],
    2018: ['6-6l-l5p', '2-8l-lwn'],
    2019: ['6-6l-l5p', '2-8l-lwn'],
    2020: ['6-6l-l5p', '2-8l-lwn', '3-0l-lm2'],
    2021: ['6-6l-l5p', '2-8l-lwn', '3-0l-lm2'],
    2022: ['6-6l-l5p', '3-0l-lm2'],
    2023: ['6-6l-l5p'],
    2024: ['6-6l-l5p'],
    2025: ['6-6l-l5p'],
    2026: ['6-6l-l5p'],
  },
  nissan: {
    2016: ['5-0l'],
    2017: ['5-0l'],
    2018: ['5-0l'],
    2019: ['5-0l'],
  },
  /** Jeep EcoDiesel 3.0L (WK2 + Wrangler/Gladiator) — 2014–2023 */
  jeep: {
    2014: ['3-0l'],
    2015: ['3-0l'],
    2016: ['3-0l'],
    2017: ['3-0l'],
    2018: ['3-0l'],
    2019: ['3-0l'],
    2020: ['3-0l'],
    2021: ['3-0l'],
    2022: ['3-0l'],
    2023: ['3-0l'],
  },
  /** Mercedes Sprinter 3.0L — 2010–2023 */
  sprinter: {
    2010: ['3-0l'],
    2011: ['3-0l'],
    2012: ['3-0l'],
    2013: ['3-0l'],
    2014: ['3-0l'],
    2015: ['3-0l'],
    2016: ['3-0l'],
    2017: ['3-0l'],
    2018: ['3-0l'],
    2019: ['3-0l'],
    2020: ['3-0l'],
    2021: ['3-0l'],
    2022: ['3-0l'],
    2023: ['3-0l'],
  },
};

const ENGINE_LABELS = {
  '2-8l-lwn': '2.8L LWN',
  '3-0l': '3.0L',
  '3-0l-lm2': '3.0L LM2',
  '5-0l': '5.0L',
  '6-0l': '6.0L',
  '6-4l': '6.4L',
  '6-6l-l5p': '6.6L L5P',
  '6-6l-lly-lbz': '6.6L LLY/LBZ',
  '6-6l-lml': '6.6L LML',
  '6-6l-lmm': '6.6L LMM',
  '6-7l': '6.7L',
  '7-3l': '7.3L',
};

const { createApp } = Vue;

const app = createApp({
  data() {
    return {
      brands: [
        { name: 'Ford', dataKey: 'ford' },
        {
          name: 'Ram Cummins',
          dataKey: 'dodge-ram',
          filterMake: 'Ram Cummins',
        },
        {
          name: 'Ram EcoDiesel',
          dataKey: 'ram-ecodiesel',
          filterMake: 'Ram EcoDiesel',
        },
        {
          name: 'GM/Chevy',
          dataKey: 'gm-chevy',
          filterMake: 'GM/CHEVY',
        },
        { name: 'Jeep', dataKey: 'jeep' },
        { name: 'Nissan', dataKey: 'nissan' },
        {
          name: 'Mercedes',
          dataKey: 'sprinter',
          filterMake: 'Sprinter',
        },
      ],
      years: [],
      engines: [],
      selectedBrand: '',
      selectedYear: '',
      selectedEngine: '',
      validationBrand: true,
      validationYear: true,
      validationEngine: true,
      isDropdownOpen: {
        brand: false,
        year: false,
        engine: false,
      },
      bannerFormEl: null,
      bannerSubmitBound: null,
    };
  },
  methods: {
    slugToEngineLabel(slug) {
      return ENGINE_LABELS[slug] ?? String(slug);
    },

    toggleDropdown(field) {
      if (
        field === 'brand' ||
        (this.selectedBrand && field === 'year') ||
        (this.selectedBrand && this.selectedYear && field === 'engine')
      ) {
        this.isDropdownOpen[field] = !this.isDropdownOpen[field];
        for (const item in this.isDropdownOpen) {
          if (item !== field && this.isDropdownOpen[item] === true) {
            this.isDropdownOpen[item] = false;
          }
        }
      } else {
        event.preventDefault();
      }
    },

    selectOption(field, option) {
      if (field === 'brand') {
        this.selectedYear = '';
        this.selectedEngine = '';
      }

      this[
        field === 'brand'
          ? 'selectedBrand'
          : field === 'year'
            ? 'selectedYear'
            : 'selectedEngine'
      ] = option;
      this.isDropdownOpen[field] = false;

      if (field === 'brand') {
        this.applyBrandFitment();
      }
      if (field === 'year') {
        this.selectedEngine = '';
        this.updateEnginesForSelectedYear();
      }
    },

    makeFilterSubmitValue() {
      const b = this.selectedBrand;
      if (!b || typeof b !== 'object') return '';
      if (b.filterMake != null && String(b.filterMake).length) {
        return String(b.filterMake);
      }
      return String(b.name ?? '');
    },

    validateBannerFields() {
      let isValid = true;

      if (!this.selectedBrand) {
        this.validationBrand = false;
        isValid = false;
        setTimeout(() => {
          this.validationBrand = true;
        }, 2000);
      }

      if (!this.selectedYear) {
        this.validationYear = false;
        isValid = false;
        setTimeout(() => {
          this.validationYear = true;
        }, 2000);
      }

      if (!this.selectedEngine) {
        this.validationEngine = false;
        isValid = false;
        setTimeout(() => {
          this.validationEngine = true;
        }, 2000);
      }

      return isValid;
    },

    handleSearchSubmit(event) {
      event.preventDefault();
      if (!this.validateBannerFields()) return;

      const q = new URLSearchParams();
      q.set('sort_by', 'price-descending');
      q.set('filter.p.m.custom.engine', String(this.selectedEngine));
      q.set('filter.p.m.custom.make', this.makeFilterSubmitValue());
      q.set('filter.p.m.custom.year', String(this.selectedYear));
      window.location.assign(`/collections/all?${q.toString()}`);
    },

    closeDropdowns(event) {
      const bannerElement = document.getElementById('banner');
      if (event.target !== bannerElement && !bannerElement.contains(event.target)) {
        this.isDropdownOpen.brand = false;
        this.isDropdownOpen.year = false;
        this.isDropdownOpen.engine = false;
      }
    },

    applyBrandFitment() {
      this.years = [];
      this.engines = [];

      const brand = this.selectedBrand;
      const key = brand?.dataKey;
      const tree = key ? FITMENT_TREE[key] : null;
      if (!tree) return;

      this.years = Object.keys(tree)
        .map(String)
        .sort((a, b) => Number(b) - Number(a));

      if (this.selectedYear) this.updateEnginesForSelectedYear();
    },

    updateEnginesForSelectedYear() {
      const brand = this.selectedBrand;
      const key = brand?.dataKey;
      const tree = key ? FITMENT_TREE[key] : null;
      const year = String(this.selectedYear || '');

      if (!tree || !year) {
        this.engines = [];
        return;
      }

      const slugs = tree[year] ?? tree[String(Number(year))] ?? [];
      const labels = [];
      const seen = Object.create(null);
      for (const slug of slugs) {
        const label = this.slugToEngineLabel(slug);
        if (!seen[label]) {
          seen[label] = true;
          labels.push(label);
        }
      }

      this.engines = labels.sort((a, b) =>
        a.localeCompare(b, undefined, {
          sensitivity: 'base',
          numeric: true,
        }),
      );
    },
  },
  mounted() {
    document.addEventListener('click', this.closeDropdowns);
    this.bannerFormEl = document.querySelector('#banner form');
    if (this.bannerFormEl) {
      this.bannerSubmitBound = (e) => this.handleSearchSubmit(e);
      this.bannerFormEl.addEventListener('submit', this.bannerSubmitBound);
    }
  },
  unmounted() {
    document.removeEventListener('click', this.closeDropdowns);
    if (this.bannerFormEl && this.bannerSubmitBound) {
      this.bannerFormEl.removeEventListener('submit', this.bannerSubmitBound);
    }
  },
});

app.mount('#banner');